import Grid from "@mui/material/Grid2";


/**
 * TopBarGridContainer component.
 *
 * This component provides a container grid for top bar content, applying consistent styling and layout properties.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {JSX.Element[]} props.children - The child components or elements to be rendered inside the grid container.
 * @param {object} [props.sx] - Custom style overrides using the `sx` prop from MUI (optional).
 *
 * @returns {JSX.Element} - The JSX element for the top bar grid container.
 */
function TopBarGridContainer({ children, sx }) {
  return (
    <Grid
      container
      direction="row"
      alignItems="flex-start"
      sx={{ maxWidth: '100%', px: 5, py: 5, ...sx }}
    >
      {children}
    </Grid>
  );
}
export default TopBarGridContainer;